import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const handleLinkClick = () => setIsMobileMenuOpen(false);
  return <>
      {}
      <div className="hidden md:flex items-center gap-8">
        {loading ? <div className="flex gap-6">
            {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-5 w-20 bg-slate-100 animate-pulse rounded-sm" />)}
          </div> : <NavigationMenu viewport={false}>
            <NavigationMenuList className="gap-8">
              {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                  <NavigationMenuLink asChild>
                    <Link to={item.href || "#"} className="text-[15.4px] font-bold text-white/90 hover:text-white hover:underline underline-offset-8 transition-all duration-300">
                      {item.label}
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>)}
            </NavigationMenuList>
          </NavigationMenu>}
      </div>

      {}
      <div className="md:hidden">
        <Button variant="ghost" size="icon" onClick={toggleMobileMenu} className="text-white hover:bg-white/10 hover:text-white" aria-label="Öppna meny">
          {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>
      </div>

      {}
      {isMobileMenuOpen && <div className="fixed inset-0 top-[var(--header-height)] z-40 bg-white/98 backdrop-blur-xl border-t border-slate-100 md:hidden flex flex-col p-6 animate-in slide-in-from-top-5 fade-in duration-200">
          <nav className="flex flex-col gap-6 mt-4">
            {loading ? <div className="flex flex-col gap-4">
                {[1, 2, 3].map(i => <div key={i} data-index={i} className="h-8 w-32 bg-slate-100 animate-pulse rounded-sm" />)}
              </div> : menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} onClick={handleLinkClick} className="text-xl font-medium text-slate-900 hover:text-primary transition-colors tracking-tight">
                  {item.label}
                </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Navigering() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header data-section-id="45479" id="header" className="header sticky top-0 z-50 w-full shadow-sm border-white/10 transition-all duration-500 ease-in-out bg-[#11263C] !h-[100px]">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
        {}
        <Link to="/HomePage" className="relative z-50 flex items-center gap-2 group">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/image_6l0u36z3.png" alt="Logik Ekonomi Sverige AB Logo" className="object-contain transition-transform duration-300 group-hover:scale-105 !h-[60px]" />
        </Link>

        {}
        <MenuProvider menu_id="41" className="flex-1 flex justify-end">
          <HeaderContent />
        </MenuProvider>
      </div>
    </header>;
}